<!-- Zweck: Stellt die HTML-Struktur für shop view result table compontent im Frontend bereit. -->
@if ((entries|async) && (entries|async)?.length > 0) {
  <div class="infoline">
    @if (infoText) {
      <div class="infobox">
        {{infoText}}
      </div>
    }
    @if ((viewcomp && viewcomp.show_warning|async)) {
      <div class="infobox warning">
        <svg-icon>warning</svg-icon>
        <div class="text">{{view.settings.warning_above_amount_text}}</div>
      </div>
    }
    <div class="addfieldbox">
      <view-field-selector label="Anzuzeigende Felder" class="tut_shopview_fields" [(fields)]="active_fields"
        [hidden_fields]="getHiddenFields()" (change)="updateView()"></view-field-selector>
    </div>
    <div style="clear: both"></div>
  </div>
  <div style="clear: both"></div>
  <div class="tableholder" [class.mobile]="msvc.isMobile()|async">
    <table class="table tablebody-striped" style="width: auto" [class.autofit]="has_bez_field|async">
      <thead>
        <tr>
          @for (fieldname of view_fields$|async; track fieldname) {
            <th class="header header_{{fieldname}}">
              <view-field-label-render [showShortLabel]="true" [fieldname]="fieldname" mode="table"></view-field-label-render>
            </th>
          }
          <th></th>
        </tr>
      </thead>
      @for (artikel of entries|async; track artikel.ArtikelNummer) {
        <tbody data-track-content
               [attr.data-content-name]="'Artikel '+(artikel.ArtikelName ? artikel.ArtikelName : artikel.ArtikelBezeichnung)+' ('+artikel.ArtikelNummer+')'">
        <tr>
          @for (fieldname of view_fields$|async; track fieldname) {
            <td class="field field_{{fieldname}}" style="white-space: nowrap" [attr.data-content-piece]="fieldname">
              @if (fieldname == 'bezeichnung') {
                <a
                  routerLink="/shop/{{view.slug}}/{{artikel.ArtikelNummer}}" [class.highlightStrong]="artikel.AllreadyOrdered">
                  <view-field-value-render
                    [artikel]="artikel"
                    [fieldname]="fieldname"
                    mode="table"
                  ></view-field-value-render>
                </a>
                @if (cfg.domainconfig?.shop_aktionen_popup && artikel.ArtikelHatAktion && cfg.showShopAktionen(artikel)) {
                  <artikel-aktionen-button [artikel]="artikel" [view]="view" [viewcomp]="viewcomp"
                    [popupMode]="true"></artikel-aktionen-button>
                }
              }
              @if (fieldname == 'bezeichnung') {
                <view-field-value-render
                  [artikel]="artikel"
                  [fieldname]="'note'"
                  [view]="view"
                  [viewcomp]="viewcomp"
                  mode="table"
                >
                </view-field-value-render>
                @if (!cfg.domainconfig?.shop_aktionen_popup && !(view_fields$|async).includes('aktionen_button')) {
                  <view-field-value-render
                    style="display: none"
                    [artikel]="artikel"
                    [fieldname]="'aktionen_button'"
                    [view]="view"
                    [viewcomp]="viewcomp"
                    mode="table"
                  >
                  </view-field-value-render>
                }
                @if (!(view_fields$|async).includes('einkaufs_statistik_web_button')) {
                  <view-field-value-render
                    style="display: none"
                    [artikel]="artikel"
                    [fieldname]="'einkaufs_statistik_web_button'"
                    [view]="view"
                    [viewcomp]="viewcomp"
                    mode="table"
                  >
                  </view-field-value-render>
                }
              }
              @if (fieldname != 'bezeichnung') {
                <view-field-value-render
                  [artikel]="artikel"
                  [fieldname]="fieldname"
                  [view]="view"
                  [viewcomp]="viewcomp"
                  mode="table"
                ></view-field-value-render>
              }
            </td>
          }
          <td style="width: 1%; white-space: nowrap">
            <shop-view-action
              [viewcomp]="viewcomp"
              [artikel]="artikel"
              [view]="view"
            ></shop-view-action>
          </td>
        </tr>
          @if (cfg.showShopAktionen(artikel) && !cfg.domainconfig?.shop_aktionen_popup && (visible_artikel_aktionen|async) && (visible_artikel_aktionen|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
            <tr
              style="background-color: white">
              <td></td>
              <td [attr.colspan]="(view_fields$|async)?.length - 1" style="padding: 5px">
                <artikel-aktionen-details
                  [aktionen]="(visible_artikel_aktionen|async)[artikel.Artikelstamm+artikel.ArtikelNummer]"
                  [directAddToWarenkorb]="!(view.settings && view.settings.bestellblock_mode) && !['NE', 'AV', 'NG'].includes(artikel.VerfuegbarkeitsstatusCode)">
                </artikel-aktionen-details>
              </td>
            </tr>
          }
          @if ((visible_artikel_einkaufsstatistik|async) && (visible_artikel_einkaufsstatistik|async)[artikel.Artikelstamm+artikel.ArtikelNummer]) {
            <tr
              style="background-color: white">
              <td></td>
              <td [attr.colspan]="(view_fields$|async)?.length - 1" style="padding: 5px">
                <einkaufs-statitik-web-details [statistik]="artikel.EinkaufsStatistikWeb"></einkaufs-statitik-web-details>
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
}
